import React from "react";
import { useNavigate } from "react-router-dom";
import { isLoggedIn, getSubsite } from '../reducers/auth';
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Image from "react-bootstrap/Image";

const PRICING_TYPES = {
  FLAT: 1,
  QUANTITY: 2,
  BILL_LATER: 3
};

const apiUrl = process.env.REACT_APP_LOCALHOST_URL;

const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  if (url.includes('uploads')) return apiUrl + url;
  return url;
};

const PrintItemCard = (props) => {
  const navigate = useNavigate();
  const loginStatus = useSelector(isLoggedIn);
  const currentSubsite = useSelector(getSubsite);
  const item = props.item;

  console.log("PrintItemCard rendering:", item);

  const getPriceDisplay = () => {
    if (!loginStatus || (currentSubsite.paymentOptions && currentSubsite.paymentOptions === "itemlimit")) {
      return null;
    }

    if (item.pricingType === PRICING_TYPES.QUANTITY && item.quantityPrices?.length > 0) {
      const prices = item.quantityPrices.map(qp => qp.price);
      const minPrice = Math.min(...prices);
      const maxPrice = Math.max(...prices);
      if (minPrice === maxPrice) {
        return `$${minPrice.toFixed(2)}`;
      }
      return `$${minPrice.toFixed(2)} - $${maxPrice.toFixed(2)}`;
    }

    if (item.pricingType === PRICING_TYPES.BILL_LATER) {
      return "Billed Later";
    }

    // Flat pricing
    return item.price ? `$${item.price.toFixed(2)}` : null;
  };

  const handleClick = () => {
    const id = item.printItemId || item.id;
    if (!id) return;
    // In admin contexts, navigate to the subsite-specific details page where
    // per-subsite personalization fields are configured. The global edit form
    // remains available from the Super Admin "Print Items" menu.
    const target = props.adminMode
      ? `/admin/printitem/details/${id}`
      : `/printitem/${id}`;
    navigate(target, { replace: false });
  };

  return (
    <Col xs={12} sm={6} md={4} lg={3} style={{ paddingRight: 4, paddingLeft: 4, paddingBottom: 4, paddingTop: 4 }}>
      <div className="product" onClick={handleClick}>
        <Container>
          <Row>
            <Col>
              <div className="main-image-container modelImage">
                <div style={{ display: "inline-block", position: "relative" }}>
                  <Image 
                    className="modelImageImg" 
                    src={getImageUrl(item.imageUrl || item.thumbUrl)} 
                    fluid 
                    style={{ maxHeight: 200, objectFit: 'contain' }}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="title">{item.title}</div>
            </Col>
          </Row>
          <Row>
            <Col>
              {getPriceDisplay() && (
                <div className="price" style={item.pricingType === PRICING_TYPES.BILL_LATER ? { color: '#666', fontStyle: 'italic' } : {}}>
                  {getPriceDisplay()}
                </div>
              )}
              {item.code && (
                <div className="text-muted small">{item.code}</div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </Col>
  );
};

export default PrintItemCard;

